import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import AnaliseOperacionalModal from '../../../../../components/AnaliseOperacionalModal/AnaliseOperacionalModal';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import GenericContent from '../../../../../components/CrudWithSteps/components/GenericContent';
import { CustomButton } from '../../../../../components/CustomButton';
import CustomDownloadButton from '../../../../../components/CustomDownloadButton/CustomDownloadButton';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import HistoricoAnaliseOperacionalModal from '../../../../../components/HistoricoAnaliseOperacionalModal/HistoricoAnaliseOperacionalModal';
import CloudDownloadIcon from '../../../../../components/Icons/CloudDownloadIcon';
import DislikeIcon from '../../../../../components/Icons/DislikeIcon';
import HistoryRoundedIcon from '../../../../../components/Icons/HistoryRoundedIcon';
import LikeIcon from '../../../../../components/Icons/LikeIcon';
import { Row } from '../../../../../components/Row';
import {
  CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_APROVADO,
  CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_REJEITADO,
} from '../../../../../library/ContratoEntePublicoAcaoAvalia';
import { CONTRATO_STATUS_EM_ANALISE } from '../../../../../library/ContratoStatus';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';
import { contratosRoute } from '../../../../../library/Routes';
import {
  downloadContrato,
  downloadDocumentoById,
  downloadContratoByIdContratoVersaoContrato,
} from '../../../../../store/modules/ContratosActions';
import {
  contratoEntePublicoReturnAnaliseOperacional,
  uploadNaoAssinadoPlanoTrabalhoEntePublico,
} from '../../../../../store/modules/ContratosEntePublicoActions';
import {
  changeModalProps,
  closeModal,
  openModal,
} from '../../../../../store/modules/ModalActions';
import { getContentTypeByUrl } from '../../../../../utils/FileUtils';
import { getElementID } from '../../../../../utils/HTMLUtils';
import {
  CONTRATO_ENTE_PUBLICO_NAO_ASSINADO_FILE_TYPES,
  CONTRATO_ENTE_PUBLICO_NAO_ASSINADO_MAX_FILE_SIZE,
  uploadFileValidation,
} from '../../../../../utils/ValidationUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './AnaliseOperacional.scss';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-ente-publico-analise-operacional';

const INITIAL_STATE = {
  sending: false,
  downloadValidacaoModalKey: null,
  analiseOperacionalModalKey: null,
};

class AnaliseOperacional extends GenericContent {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return this.contratoIsLoading() ? null : (
      <>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          ></Col>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.props.languageValues.cadastroContratoRevisoes}
              theme='pufvYellow'
              onClick={this.toRevisoes}
              rightIcon={<HistoryRoundedIcon />}
              disabled={this.revisoesIsDisabled()}
              counter={this.getRevisoesCounter()}
            />
          </Col>
        </Row>
        <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-left'}
          >
            <CustomButton
              label={this.props.languageValues.aprovarDocumentoContrato}
              theme='default'
              onClick={this.toApprove}
              leftIcon={<LikeIcon />}
              disabled={false}
            />
          </Col>
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.props.languageValues.reprovarDocumentoContrato}
              theme='error'
              onClick={this.toDisapprove}
              leftIcon={<DislikeIcon />}
              disabled={false}
            />
          </Col>
        </Row>
      </>
    );
  };

  toSubmitReturnFromAnaliseOperacional = (text, file, approve) => {
    return new Promise((resolve, reject) => {
      const flgFilePrincipal = approve && file ? true : false;
      this.changeSendingStatus(true).then(() => {
        this.props.contratoEntePublicoReturnAnaliseOperacional(
          {
            file: file,
            acaoAvalia: approve
              ? CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_APROVADO
              : CONTRATO_ENTE_PUBLICO_ACAO_AVALIA_REJEITADO,
            flgFilePrincipal: flgFilePrincipal,
            idPlanoTrabalho:
              this.props.contratosEntePublico.contratoEditing.idPlanoTrabalho,
            idContrato: this.props.utils.getIdOfVersao(),
            versaoContrato:
              this.props.contratosEntePublico.contratoEditing.versaoContrato,
            comentario: text,
          },
          () => "",
          () => {
            resolve();
            SnackbarUtils.enqueueSnackbar({
              message:
                this.props.languageValues.successReturningAnaliseOperacional,
              options: {
                variant: 'success',
              },
            });
            this.props.closeModal(this.state.analiseOperacionalModalKey);
            this.props.history.push(contratosRoute.path);
          },
          (error) => {
            reject();
            SnackbarUtils.enqueueSnackbar({
              message:
                error.response.statusText ||
                this.props.languageValues.errorReturningAnaliseOperacional,
              options: {
                variant: 'error',
              },
            });
            this.changeSendingStatus(false);
          }
        );
      });
    });
  };

  changeSendingStatus = (status) => {
    return new Promise((resolve,) => {
      if (this.state.sending !== status) {
        this.setState(
          {
            sending: status,
          },
          () => {
            resolve();
            if (this.state.analiseOperacionalModalKey)
              this.props.changeModalProps(
                this.state.analiseOperacionalModalKey,
                {
                  loading: this.state.sending,
                }
              );
          }
        );
      } else {
        resolve();
      }
    });
  };

  openReturnAnaliseOperacional = (approve) => {
    const analiseOperacionalModalKey = this.props.openModal(
      AnaliseOperacionalModal,
      {
        loading: this.state.sending,
        idContrato: this.props.utils.getIdOfVersao(),
        versaoContrato:
          this.props.contratosEntePublico.contratoEditing.versaoContrato,
        title: this.props.languageValues.cadastroContratoFinalizarRevisao,
        descriptionLabel:
          this.props.languageValues
            .cadastroContratoAnaliseOperacionalJustificativa,
        submitButtonLabel: approve
          ? this.props.languageValues.aprovarDocumentoContrato
          : this.props.languageValues.reprovarDocumentoContrato,
        uploadFile: true,
        uploadFileValidation: this.fileIsValid,
        submitCallback: (text, file, jobFile) => {
          const handleError = (error) =>
            SnackbarUtils.enqueueSnackbar({
              message:
                error.response.statusText ||
                this.props.languageValues.errorReturningAnaliseOperacional,
              options: {
                variant: 'error',
              },
            });

          const finish = (resolve, reject) => {
            this.toSubmitReturnFromAnaliseOperacional(text, file, approve)
              .then(() => {
                resolve();
              })
              .catch((error) => {
                reject();
                handleError(error);
              });
          };

          const uploadPlano = (callbackSuccess, reject) => {
            this.props.uploadNaoAssinadoPlanoTrabalhoEntePublico(
              jobFile,
              () => "",
              callbackSuccess,
              (error) => {
                handleError(error);
                reject();
              }
            );
          };

          return new Promise((resolve, reject) => {
            if (jobFile) {
              uploadPlano(() => {
                finish(resolve, reject);
              }, reject);
            } else {
              finish(resolve, reject);
            }
          });
        },
      }
    ).payload.key;

    this.setState({
      analiseOperacionalModalKey: analiseOperacionalModalKey,
    });
  };

  toApprove = () => {
    this.openReturnAnaliseOperacional(true);
  };

  toDisapprove = () => {
    this.openReturnAnaliseOperacional();
  };

  toRevisoes = () => {
    this.props.openModal(HistoricoAnaliseOperacionalModal, {
      utils: this.props.utils,
      historico:
        this.props.contratosEntePublico.contratoEditing
          .historicoAnaliseOperacional,
    });
  };

  revisoesIsDisabled = () => {
    return (
      this.state.sending ||
      this.props.loading ||
      this.props.contratosEntePublico.contratoEditing
        .loadingHistoricoAnaliseOperacional ||
      (this.getRevisoesCounter() ? false : true)
    );
  };

  getRevisoesCounter = () => {
    const counter =
      this.props.contratosEntePublico.contratoEditing
        .historicoAnaliseOperacional.length;
    return !this.props.loading && counter > 0 ? counter : null;
  };

  downloadValidacaoIsDisabled = () => {
    return (
      this.state.sending ||
      !this.props.contratosEntePublico.contratoEditing.ativo ||
      this.props.loading ||
      !this.props.auth.userPermissions.contratos.entePublico.analiseOperacional
        .edit ||
      this.props.contratosEntePublico.contratoEditing.flgStatus === -1 ||
      this.props.contratosEntePublico.contratoEditing.flgStatus !==
        CONTRATO_STATUS_EM_ANALISE
    );
  };

  downloadValidacaoPlanoTrabalhoIsDisabled = () => {
    return (
      this.state.sending ||
      !this.props.contratosEntePublico.contratoEditing.ativo ||
      this.props.loading ||
      !this.props.contratosEntePublico.contratoEditing.idPlanoTrabalho ||
      !this.props.auth.userPermissions.contratos.entePublico.analiseOperacional
        .edit ||
      this.props.contratosEntePublico.contratoEditing.flgStatus === -1 ||
      this.props.contratosEntePublico.contratoEditing.flgStatus !==
        CONTRATO_STATUS_EM_ANALISE
    );
  };

  getTitle = () => {
    switch (this.props.contratosEntePublico.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        return this.props.languageValues
          .cadastroContratoAnaliseOperacionalAditivo;
      case CONTRATO_VERSAO_DISTRATO:
        return this.props.languageValues
          .cadastroContratoAnaliseOperacionalDistrato;
      case CONTRATO_VERSAO_CONTRATO:
      default:
        return this.props.languageValues
          .cadastroContratoAnaliseOperacionalContrato;
    }
  };

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>{this.getTitle()}</CardTitle>
        ),
        actions: this.getActions(),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.state.sending || this.contratoIsLoading(),
      },
    };
  };

  contratoIsLoading = () => {
    return (
      this.props.loading ||
      this.props.contratosEntePublico.loadingHtmlContrato ||
      this.props.contratosEntePublico.loadingHistoricoAnaliseOperacional
    );
  };

  fileIsValid = (file) => {
    return uploadFileValidation(
      file,
      CONTRATO_ENTE_PUBLICO_NAO_ASSINADO_FILE_TYPES,
      CONTRATO_ENTE_PUBLICO_NAO_ASSINADO_MAX_FILE_SIZE,
      this.props.languageValues.errorFileTypeContrato,
      this.props.languageValues.errorFileSizeContrato
    );
  };

  toDownloadPlano = (
    params,
    callbackProgress,
    callbackSuccess,
    callbackError
  ) => {
    const onProgress = (event) => {
      callbackProgress(event.loaded / event.total);
    };
    this.props.downloadContratoByIdContratoVersaoContrato(
      params.id,
      params.versaoContrato,
      params.contentType,
      onProgress,
      callbackSuccess,
      callbackError
    );
  };

  getFileName = () => {
    return (
      this.props.utils.getContratoPlanoTrabalhoFileName() +
      '.' +
      this.props.arquivo.extencaoArquivoPlanoTrabalho
    );
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        {this.contratoIsLoading() ? (
          <Row>
            <Col cols={[12, 12, 12, 12, 12]}>
              {this.props.utils.getDocumentoPreloaderMessage()}
            </Col>
          </Row>
        ) : (
          <Row>
            <Col
              cols={[6, 6, 6, 6, 6]}
              className={rootClassName + '-download-column'}
            >
              <CustomDownloadButton
                id={getElementID(rootElementId, 'download')}
                className={rootClassName + '-download-nao-assinado'}
                label={'Contrato Não Assinado'}
                downloadAction={this.props.downloadContrato}
                downloadActionData={{
                  fileName:
                    this.props.contratosEntePublico.contratoEditing
                      .ultimaAvaliaEnviado.caminho,
                  contentType: getContentTypeByUrl(
                    '.' +
                      this.props.contratosEntePublico.contratoEditing
                        .ultimaAvaliaEnviado.extencaoArquivo
                  ),
                }}
                buttonComponent={CustomButton}
                buttonComponentProps={{
                  theme: 'primary',
                  leftIcon: <CloudDownloadIcon />,
                  counter: 0,
                  tooltip:
                    this.props.languageValues
                      .cadastroContratoArquivosDownloadNaoAssinado,
                  disabled: this.downloadValidacaoIsDisabled(),
                }}
                fileName={
                  this.props.utils.getContratoValidacaoFileName() +
                  '.' +
                  this.props.contratosEntePublico.contratoEditing
                    .ultimaAvaliaEnviado.extencaoArquivo
                }
                hideLabel={false}
                feedbackOnModal={true}
                feedbackOnModalTitle={
                  this.props.languageValues
                    .cadastroContratoArquivosDownloadingNaoAssinado
                }
              />
            </Col>
            <Col
              cols={[6, 6, 6, 6, 6]}
              className={rootClassName + '-download-column'}
            >
              <CustomDownloadButton
                id={getElementID(rootElementId, 'download')}
                label={'Plano de trabalho'}
                className={rootClassName + '-download-nao-assinado'}
                downloadAction={this.toDownloadPlano}
                downloadActionData={{
                  id: this.props.utils.getIdOfVersao(),
                  versaoContrato:
                    this.props.contratosEntePublico.contratoEditing
                      .versaoContrato,
                  contentType:
                    this.props.contratosEntePublico.contratoEditing
                      .extencaoArquivoPlanoTrabalho,
                }}
                buttonComponent={CustomButton}
                buttonComponentProps={{
                  theme: 'default',
                  leftIcon: <CloudDownloadIcon />,
                  counter: 0,
                  tooltip:
                    this.props.languageValues
                      .cadastroContratoArquivosDownloadNaoAssinado,
                  disabled: this.downloadValidacaoPlanoTrabalhoIsDisabled(),
                }}
                fileName={
                  this.props.utils.getContratoPlanoTrabalhoFileName() +
                  '.' +
                  this.props.contratosEntePublico.contratoEditing
                    .extencaoArquivoPlanoTrabalho
                }
                hideLabel={false}
                feedbackOnModal={true}
                feedbackOnModalTitle={
                  this.props.languageValues
                    .cadastroContratoArquivosDownloadingNaoAssinado
                }
              />
            </Col>
          </Row>
        )}
      </GenericCardScreen>
    );
  }
}

AnaliseOperacional.propTypes = {
  etapaValidacaoIsEnabled: PropTypes.func.isRequired,
  toEtapaValidacao: PropTypes.func.isRequired,
  utils: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  refreshStep: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePublico: state.contratosEntePublico,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      closeModal,
      changeModalProps,
      downloadContrato,
      downloadDocumentoById,
      downloadContratoByIdContratoVersaoContrato,
      contratoEntePublicoReturnAnaliseOperacional,
      uploadNaoAssinadoPlanoTrabalhoEntePublico,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AnaliseOperacional));
